import { z } from 'zod';

export type ReportReviewModalPropsMicrocopy = {
  title: string;
  subtitle: string;
  placeholder: string;
  description: string;
  close: string;
  primaryCta: string;
  secondaryCta: string;
  triggerLabel: string;
};

export const MAX_REPORT_REVIEW_CHARS = 3000;

export const reportReviewFormSchema = z.object({
  reportReview: z.string().min(1).max(MAX_REPORT_REVIEW_CHARS),
});

export type ReportReviewModalData = z.infer<typeof reportReviewFormSchema>;

export type ReportReviewModalPropsActions = {
  onSubmitReport: (data: ReportReviewModalData) => void;
};

export type ReportReviewModalProps = ReportReviewModalPropsActions & {
  microcopy: ReportReviewModalPropsMicrocopy;
  className?: string;
};
